import { render } from "./MatingOverview.vue?vue&type=template&id=7cffac67&scoped=true"
import script from "./MatingOverview.vue?vue&type=script&lang=js"
export * from "./MatingOverview.vue?vue&type=script&lang=js"

import "./MatingOverview.vue?vue&type=style&index=0&id=7cffac67&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cffac67"]])

export default __exports__